module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/photography-wideAngle-mobile.6a1b2e77.webp";